import type { LabeledValuePayload } from '@Application/Users/UserStatuses/Actions/userStatusesFetched';

/**
 * One row of `GET …/imported-documents`. `beneficiary` and `importedBy` are relations, `{ id }` only.
 * The converted text is never exposed.
 */
export type ImportedDocumentPayload = {
	readonly id: number;
	readonly beneficiary: { readonly id: number } | null;
	readonly name: string;
	readonly description: string | null;
	readonly format: LabeledValuePayload;
	readonly status: LabeledValuePayload;
	readonly failureMessage: string | null;
	readonly importedAt: string;
	readonly importedBy: { readonly id: number } | null;
	readonly convertedAt: string | null;
};

export type ImportedDocumentsPayload = {
	totalRecords: number;
	results: ImportedDocumentPayload[];
};

export type ImportedDocumentsFetchedAction = {
	type: 'IMPORTED_DOCUMENTS_FETCHED';
	payload: ImportedDocumentsPayload;
	subjectId: number;
	typeKey: string;
};

export default (
	payload: ImportedDocumentsPayload,
	subjectId: number,
	typeKey: string,
): ImportedDocumentsFetchedAction => ({
	type: 'IMPORTED_DOCUMENTS_FETCHED',
	payload,
	subjectId,
	typeKey,
});
